import CloseIcon from "@mui/icons-material/Close";
import { Box, Fade, Modal, type SxProps, Typography, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React, { useState } from "react";

import ConfirmDiscardChanges from "@/components/ModalForms/ConfirmDiscardChanges.tsx";

export default function SimpleModalFix({
  open,
  children,
  confirmDiscard,
  closeModal,
  title,
  innerSx,
  sx,
}: {
  open: boolean;
  children: React.ReactNode;
  closeModal?: () => void;
  footerSlot?: React.ReactNode;
  title?: string | React.ReactNode;
  sx?: SxProps;
  innerSx?: SxProps;
  confirmDiscard?: boolean;
}) {
  const theme = useTheme();
  const [confirmBeforeClose, setConfirmBeforeClose] = useState<boolean>(false);

  const handleClose = () => {
    if (confirmDiscard && !confirmBeforeClose) {
      setConfirmBeforeClose(() => true);
      return;
    }
    closeModal();
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      aria-hidden={!open}
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(8px)",
        zIndex: theme.zIndex.modal + 10,
      }}
    >
      <>
        {confirmBeforeClose && (
          <ConfirmDiscardChanges
            id="discard-simple-modal-message"
            visible={confirmBeforeClose}
            denyCloseHandler={() => setConfirmBeforeClose(() => false)}
            confirmCloseHandler={() => handleClose()}
          />
        )}
        <Box
          sx={{
            background: theme.palette.secondary.dark,
            width: "600px",
            position: "relative",
            p: 2,
            pt: 1,
            borderRadius: "1rem",
            outline: "none !important",
            ...sx,
          }}
        >
          <Box sx={{ height: "50px", mb: 1, display: "flex", width: "100%" }}>
            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton size="small" aria-label="close" color="primary" onClick={(e) => handleClose()}>
                <CloseIcon role="img" />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              maxHeight: "calc(100vh - 153px)",
              overflowY: "auto",
              ...innerSx,
            }}
          >
            {children}
          </Box>
        </Box>
      </>
    </Modal>
  );
}
